export default __webpack_public_path__ + "static/media/elina@3x.63b87109.png";